import type React from 'react';

import type { LinkComponent } from '@tanstack/react-router';
import { createLink } from '@tanstack/react-router';
import { twMerge } from 'tailwind-merge';

type BasicLinkProps = React.ComponentProps<'a'> & {
  containerClassName?: string;
  className?: string;
};

const BasicLinkComponent = ({
  ref,
  children,
  className,
  containerClassName,
  ...props
}: BasicLinkProps & {
  ref?: React.RefObject<HTMLAnchorElement | null>;
}) => {
  return (
    <a ref={ref} {...props} className={twMerge('group pointer-events-auto', containerClassName)}>
      <span className={twMerge('decoration-primary decoration-2 group-hover:underline', className)}>{children}</span>
    </a>
  );
};

const CreatedLinkComponent = createLink(BasicLinkComponent);

export const PrimaryLink: LinkComponent<typeof BasicLinkComponent> = (props) => {
  return <CreatedLinkComponent preload={'intent'} {...props} />;
};
